import { NavLink, Outlet, Link } from "react-router-dom";
import {
  LayoutDashboard, Users, Building2, List, FolderTree, ClipboardList, Flag, MessagesSquare, Star, ArrowLeft,
} from "lucide-react";
import { cn } from "@/lib/utils";

const MENU = [
  { to: "/admin", end: true, label: "Genel Bakış", icon: LayoutDashboard },
  { to: "/admin/kullanicilar", label: "Kullanıcılar", icon: Users },
  { to: "/admin/kurumsal", label: "Kurumsal Hesaplar", icon: Building2 },
  { to: "/admin/ilanlar", label: "İlanlar", icon: List },
  { to: "/admin/kategoriler", label: "Kategoriler", icon: FolderTree },
  { to: "/admin/alim-talepleri", label: "Alım Talepleri", icon: ClipboardList },
  { to: "/admin/sikayetler", label: "Şikayetler", icon: Flag },
  { to: "/admin/mesajlar", label: "Mesaj Denetimi", icon: MessagesSquare },
  { to: "/admin/one-cikan", label: "Öne Çıkan İlanlar", icon: Star },
];

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto flex max-w-[1500px]">
        <aside className="sticky top-0 hidden h-screen w-64 shrink-0 flex-col border-r border-slate-200 bg-white lg:flex">
          <div className="border-b border-slate-200 p-5">
            <Link to="/" className="flex items-center gap-2 text-sm text-slate-500 hover:text-emerald-700"><ArrowLeft size={16} /> Siteye Dön</Link>
            <p className="mt-3 font-display text-lg font-extrabold text-emerald-900">Yönetim Paneli</p>
          </div>
          <nav className="flex-1 space-y-1 p-3">
            {MENU.map((m) => (
              <NavLink key={m.to} to={m.to} end={m.end} data-testid={`admin-nav-${m.to.split("/").pop()}`}
                className={({ isActive }) => cn("flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                  isActive ? "bg-emerald-50 text-emerald-700" : "text-slate-600 hover:bg-slate-50")}>
                <m.icon size={18} /> {m.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        <div className="min-w-0 flex-1">
          <div className="border-b border-slate-200 bg-white px-4 py-3 lg:hidden">
            <nav className="flex gap-2 overflow-x-auto no-scrollbar">
              {MENU.map((m) => (
                <NavLink key={m.to} to={m.to} end={m.end}
                  className={({ isActive }) => cn("flex shrink-0 items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium",
                    isActive ? "border-emerald-600 bg-emerald-50 text-emerald-700" : "border-slate-200 text-slate-600")}>
                  <m.icon size={14} /> {m.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="p-4 lg:p-8"><Outlet /></div>
        </div>
      </div>
    </div>
  );
}
